import React from 'react';
import classNames from 'classnames';
import { getThemeClassNames } from 'themes';

import { MirrorService } from 'services/MirrorService';
import { AppDomain } from 'types/enums/AppDomain';

import { ReactComponent as FlameIcon } from 'assets/icons/flame.svg';
import { ReactComponent as CrownIcon } from 'assets/icons/meplusyou/vip-badge.svg';

import css from './hotUserBadge.module.sass';

interface Props {
  className?: string;
  label?: string;
}

export const HotUserBadge: React.FC<Props> = ({ className, label }) => {
  const rootTypeIconClassName = getThemeClassNames(css.rootTypeIcon, {
    [AppDomain.Meamo]: css.rootTypeIconRadius10,
    [AppDomain.Uniteus]: css.rootTypeIconRadius10,
    [AppDomain.Theunite]: css.rootTypeIconRadius10,
    [AppDomain.FinderSingles]: css.rootTypeIconRadius10,
    [AppDomain.JoyFinder]: css.rootTypeIconRadius10,
    [AppDomain.FlirtGuru]: css.rootTypeIconRadius10,
    [AppDomain.FlirtDiscovery]: css.rootTypeIconRadius10,
  });
  const iconClassName = getThemeClassNames(css.icon, {
    [AppDomain.LocalsDate]: css.iconTypeLocalsDate,
    [AppDomain.LustStation]: css.iconTypeLocalsDate,
  });

  return (
    <span
      className={classNames(css.root, className, {
        [rootTypeIconClassName]: !label,
        [css.rootThememePlusYou]: MirrorService.isMePlusYouOrLocalsjoy,
      })}
    >
      {MirrorService.isMePlusYouOrLocalsjoy ? (
        <CrownIcon className={iconClassName} />
      ) : (
        <FlameIcon className={iconClassName} />
      )}
      {label}
    </span>
  );
};
